import { render, staticRenderFns } from "./upload-cover.vue?vue&type=template&id=60499998&scoped=true&"
import script from "./upload-cover.vue?vue&type=script&lang=js&"
export * from "./upload-cover.vue?vue&type=script&lang=js&"
import style0 from "./upload-cover.vue?vue&type=style&index=0&id=60499998&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60499998",
  null
  
)

export default component.exports